<ng-container *ngIf="session">
  <header class="hero-unit session-banner chrome-no-repaint" id="banner">
    <div class="container">
      <div class="col-lg-8">
        <div class="box-marked">
          <h1>{{ session.config.title }}</h1>
          <h3>{{ session.config.one_liner }}</h3>
          <!--
          <p *ngIf="session.config.description" style="white-space: pre-line">
          {{(session.config.description.substring(0, 900)) + ((session.config.description.length > 800) ? ' ...' : '')}}
          </p>
          -->
          <div class="description-holder">
            <prosemirror-view
              *ngIf="session.config.descriptionRich"
              [simplified]="true"
              [content]="session.config.descriptionRich"></prosemirror-view>
          </div>
        </div>
      </div>
      <div class="col-lg-4 header-image">
        <img
          height="100%"
          width="100%"
          alt="header-image"
          [src]="thumbnailImage" />
      </div>
    </div>

    <div class="background-image-wrapper">
      <div
        class="background-image"
        [ngStyle]="{ 'background-image': 'url(' + thumbnailImage + ')' }"></div>
    </div>
  </header>

  <!-- Subnavigation Start -->
  <div class="container-fluid sub-navigation chrome-no-repaint">
    <div class="container">
      <div class="col-lg-9 top-buffer">
        <ul>
          <li>
            <a routerLink="/topics/{{ session._id }}">
              <i class="icon-ideas"></i>
              Back to Topic Overview
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Subnavigation End -->

  <!-- IdeationSession Detail Start -->
  <div class="container ideation-module-container chrome-no-repaint">
    <ul ngbNav #nav="ngbNav">
      <li ngbNavItem="tab-0">
        <button ngbNavLink>Description</button>
        <ng-template ngbNavContent>
          <div class="content">
            <div class="col-lg-8">
              <h1>{{ session.config.title }}</h1>
              <h3>{{ session.config.one_liner }}</h3>
              <prosemirror-view
                [content]="session.config.descriptionRich"></prosemirror-view>
            </div>
            <div class="col-lg-4">
              <img width="100%" height="auto" [src]="thumbnailImage" alt />
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
  </div>
  <!-- IdeationSession Detail End -->
</ng-container>
